import { getCookie } from "../utils/cookie"
import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Industry from '../views/Industry'
import Products from '../views/Products'
import ProductView from '../views/ProductView'
import Formulations from '../views/Formulations'
import FormulationView from '../views/FormulationView'
import SampleOrder from '../views/SampleOrder'
import ContactUs from '../views/ContactUs'
import Register from '../views/Register'
import NotFound from '../views/NotFound'
import Login from '../views/Login'
import DownloadList from '../views/DownloadList'
import Download from '../views/Download'
import FormulationsFilter from '../views/FormulationsFilter'
import MyFavorites from '../views/MyFavorites'
import OrderHistory from '../views/OrderHistory'
import AccountSetting from '../views/AccountSetting'
import ForgetPass from '../views/ForgetPass'
import ResetPass from '../views/ResetPass'
import Disclaimer from '../views/Disclaimer'
import Unauthorized from '../views/Unauthorized'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Vue.use(Router)

let defaultKeywords = '巴斯夫, 化工产品, 配方, 巴斯夫产品'
let defaultDescription = '巴斯夫产品, 巴斯夫配方'

let language = getCookie('drupal:session:language') || 'en'

if ( window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.prerender === 'domain' ) { language = 'en' }

console.log(language, 'language')

if (language !== 'zh-hans') {
  defaultKeywords = 'BASF, Chemical Products, Formulations, BASF Products'
  defaultDescription = 'BASF Products, BASF Formulations'
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心' : 'BASF Product Center for Resins and Additives',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/industry',
      name: 'Industry',
      component: Industry,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_行业' : 'BASF Product Center for Resins and Additives_Industry',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_产品' : 'BASF Product Center for Resins and Additives_Products',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    // {
    //   path: '/product/:id',
    //   name: 'Product',
    //   component: ProductView,
    //   meta: {
    //     title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_产品详情页' : 'BASF Product Center for Resins and Additives --- Product Details Page',
    //     keywords: defaultKeywords,
    //     description: defaultDescription,
    //     keepAlive: true
    //   }
    // },
    {
      path: '/product',
      name: 'Product',
      component: ProductView,
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_产品详情页' : 'BASF Product Center for Resins and Additives --- Product Details Page',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/formulations',
      name: 'Formulations',
      component: Formulations,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_配方' : 'BASF Product Center for Resins and Additives_Formulations',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    // {
    //   path: '/formulation/:id',
    //   name: 'Formulation',
    //   component: FormulationView,
    //   mode: 'history',
    //   meta: {
    //     title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_配方详情页' : 'BASF Product Center for Resins and Additives --- Formula Details Page',
    //     keywords: defaultKeywords,
    //     description: defaultDescription,
    //     keepAlive: true
    //   }
    // },
    {
      path: '/formulation',
      name: 'Formulation',
      component: FormulationView,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_配方详情页' : 'BASF Product Center for Resins and Additives --- Formula Details Page',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/sample-order',
      name: 'SampleOrder',
      component: SampleOrder,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_样品订单' : 'BASF Product Center for Resins and Additives_Sample Order',
        auth: 'user-login',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      },
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: ContactUs,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_联系我们' : 'BASF Product Center for Contact US',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--登录' : 'BASF Product Center for Resins and Additives --- Login',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--注册' : 'BASF Product Center for Resins and Additives ---  Registration',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心 下载分类' : 'BASF Product Center for Resins and Additives_Download',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/downloadlist',
      name: 'DownloadList',
      component: DownloadList,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心_下载列表' : 'BASF Product Center for Resins and Additives Download list',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/formulations-filter',
      name: 'FormulationsFilter',
      component: FormulationsFilter,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--配方选择' : 'BASF Product Center for Resins and Additives ---  Select Formulation',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/my-favorites',
      name: 'MyFavorites',
      component: MyFavorites,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--我的收藏' : 'BASF Product Center for Resins and Additives ---  My Collection',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/order-history',
      name: 'OrderHistory',
      component: OrderHistory,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--订单历史' : 'BASF Product Center for Resins and Additives ---  Order History',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/account-setting',
      name: 'AccountSetting',
      component: AccountSetting,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--账户设置' : 'BASF Product Center for Resins and Additives ---  Account Setting',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: Disclaimer,
      mode: 'history',
      meta: {
        title: language === 'zh-hans' ? '巴斯夫树脂与助剂产品中心--免责声明' : 'BASF Product Center for Resins and Additives ---  Disclaimer',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized,
      mode: 'history',
    },
    {
      path: '/forget-pass',
      name: 'ForgetPass',
      component: ForgetPass,
      mode: 'history',
    },
    {
      path: '/reset-pass/:tempPass',
      name: 'ResetPass',
      component: ResetPass,
      mode: 'history',
    },
    {
      path: '/notfound',
      name: 'NotFound',
      component: NotFound,
      mode: 'history',
      meta: {
        title: '404',
        keywords: defaultKeywords,
        description: defaultDescription,
        keepAlive: true
      }
    },
    {
      path: '*',
      redirect: '/notfound'
    }
  ]
})
